export default __webpack_public_path__ + "static/media/DancingScript-VariableFont_wght.d02a1ee1.ttf";